<template>
  <v-app>
    <NavigationDrawer v-if="!hideNavigation" />
    <v-main>
      <NcrmDemoDataBanner v-if="!hideNavigation" />
      <!-- În `v-main`, lângă celelalte notificări globale: pentru utilizatorii
           care nu pot accepta în numele companiei, poarta se redă ca banner
           deasupra conținutului, nu ca dialog blocant. Dialogul pentru admin
           este teleportat de Vuetify, deci poziția din template nu îl afectează. -->
      <LegalAcceptanceGate v-if="!hideNavigation" />
      <router-view />
    </v-main>
    <ProductTourHost v-if="!hideNavigation" />
    <AppFeedbackHost />

    <v-dialog :model-value="smartTrackerPromptVisible" persistent max-width="460">
      <v-card class="smart-tracker-prompt">
        <v-card-title class="d-flex align-center ga-2">
          <v-icon color="warning">mdi-timer-sand</v-icon>
          <span class="text-subtitle-1">{{ $t("smartTracker.prompt.title") }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <p class="text-body-2 mb-2">
            {{ $t("smartTracker.prompt.description") }}
          </p>
          <v-chip color="warning">
            {{
              $t("smartTracker.prompt.countdown", {
                seconds: smartTrackerPromptCountdown,
              })
            }}
          </v-chip>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" color="warning" @click="pauseSmartTrackerNow">
            {{ $t("smartTracker.prompt.pauseNow") }}
          </v-btn>
          <v-btn color="primary" @click="confirmSmartTrackerPrompt">
            {{ $t("smartTracker.prompt.continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import AppFeedbackHost from "@/components/app/AppFeedbackHost.vue";
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import ProductTourHost from "@/components/tours/ProductTourHost.vue";
import NcrmDemoDataBanner from "@/components/ncrm/demo-data/NcrmDemoDataBanner.vue";
import LegalAcceptanceGate from "@/components/legal/LegalAcceptanceGate.vue";
import { getSmartTrackerRuntime } from "@/Utile/smartTrackerRuntime.mjs";
import { useRoute } from "vue-router";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useTheme } from "vuetify";

export default {
  components: {
    AppFeedbackHost,
    NavigationDrawer,
    ProductTourHost,
    NcrmDemoDataBanner,
    LegalAcceptanceGate,
  },
  setup() {
    const route = useRoute();
    const theme = useTheme();
    const userRole = ref(localStorage.getItem("user-role") || "");
    const smartTracker = getSmartTrackerRuntime();

    // Restore theme from localStorage, then fall back to system preference
    const savedTheme = localStorage.getItem("app-theme");
    if (savedTheme === "dark" || savedTheme === "light") {
      theme.global.name.value = savedTheme;
    } else if (window.matchMedia?.("(prefers-color-scheme: dark)")?.matches) {
      theme.global.name.value = "dark";
    }

    watch(
      () => route.path,
      (nextPath) => {
        userRole.value = localStorage.getItem("user-role") || "";
        smartTracker.setRoute(nextPath);
      }
    );

    const hideNavigation = computed(() => {
      if (route.meta?.publicAuth) {
        return true;
      }
      if (["/", "/login", "/no-company-context", "/mobile-hub"].includes(route.path)) {
        return true;
      }
      if (userRole.value === "hr") {
        return true;
      }
      return false;
    });

    const smartTrackerPromptVisible = computed(
      () => smartTracker.state.initialized && smartTracker.state.enabled && smartTracker.state.promptVisible
    );
    const smartTrackerPromptCountdown = computed(() =>
      Math.max(0, Number(smartTracker.state.promptCountdown || 0))
    );

    const confirmSmartTrackerPrompt = async () => {
      await smartTracker.confirmPrompt();
    };

    const pauseSmartTrackerNow = async () => {
      await smartTracker.pauseNow();
    };

    onMounted(() => {
      smartTracker.init(route.path);
    });

    onBeforeUnmount(() => {
      smartTracker.destroy();
    });

    return {
      hideNavigation,
      smartTrackerPromptVisible,
      smartTrackerPromptCountdown,
      confirmSmartTrackerPrompt,
      pauseSmartTrackerNow,
    };
  },
};
</script>
